import { useEffect, useState } from "react";
import Modal from "../../common/components/Modal";
import PagePermissionsForm from "./PagePermissionsForm";
import useMemberPermissions from "../../common/hooks/pages/useMemberPermissions";
import { usePopup } from "../../common/contexts/PopupContext";
import { useMutation } from "react-query";
import ApiValidate from "../../common/components/ApiValidate";
import PrimaryButton from "../../common/components/PrimaryButton";

function EditPagePermissions({ open, setOpen, memberData = {} }) {
  const [pagePermissions, setPagePermissions] = useState({});

  const [errors, setErrors] = useState({});

  const { email, userId } = memberData;

  const { toast } = usePopup();

  const { getMemberPermissions, updateMemberPermissions } =
    useMemberPermissions();

  const {
    mutate: getMemberPermissionsMutate,
    isError,
    isLoading,
  } = useMutation({
    mutationFn: getMemberPermissions,
    onSuccess: (res) => {
      const { userPermissions } = res?.data;

      const refactor = {};

      if (userPermissions?.length) {
        userPermissions.forEach((userPerm) => {
          const { _id: pageId, permissions } = userPerm;
          refactor[pageId] = permissions;
        });

        setPagePermissions(refactor);
      }
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting member permissions!";
      toast(message, "error");
    },
  });

  const { mutate: updateMemberPermissionsMutate } = useMutation({
    mutationFn: updateMemberPermissions,
    onSuccess: (res) => {
      const { message } = res?.data;

      setOpen(false);

      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating member permissions!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    getMemberPermissionsMutate({
      userId,
    });
  }, []);

  return (
    <Modal
      title={"Edit page permissions"}
      open={open}
      setOpen={setOpen}
      containerCls="md:min-w-[500px]"
    >
      <ApiValidate isLoading={isLoading} isError={isError}>
        <div className=" my-2 text-gray-500">{email}</div>

        <PagePermissionsForm
          pagePermissions={pagePermissions}
          setPagePermissions={setPagePermissions}
          error={errors?.page}
        />

        <PrimaryButton
          btnCls="mt-8"
          buttonProps={{
            onClick: () => {
              let error = {};

              if (!Object.keys(pagePermissions)?.length) {
                error.page = "Please select atleast on page";
              }

              setErrors(error);

              // if no errors,
              if (!Object.keys(error)?.length) {
                const permissions = [];

                Object.entries(pagePermissions).forEach(([key, value]) => {
                  permissions.push({
                    page: key,
                    permissions: value,
                  });
                });

                updateMemberPermissionsMutate({
                  userId,
                  permissions,
                });
              }
            },
          }}
        >
          Update
        </PrimaryButton>
      </ApiValidate>
    </Modal>
  );
}

export default EditPagePermissions;
